import { Box, Text } from '@mantine/core'
import { useTranslations } from 'next-intl'

import { AllAvailableCurrencyCodes } from '@/types/currency'

interface ConverterHeaderProps {
  coinSymbol: string
  coinName: string
  currency: AllAvailableCurrencyCodes
  currencyName: string
}

export function ConverterHeader({
  coinSymbol,
  coinName,
  currency,
  currencyName,
}: ConverterHeaderProps) {
  const tConverter = useTranslations('converter')

  return (
    <Box>
      <Text component="h1" fz={18} c="var(--content-secondary)">
        {tConverter('convertTitle', {
          coinName,
          symbol: coinSymbol,
          fiatName: currencyName,
          currency: `(${currency})`,
        })}
      </Text>
      <Text component="h2" fz={32} fw={600} lh="40px" lts={'-0.48px'}>
        {coinSymbol} to {currency}
      </Text>
    </Box>
  )
}
